import Vue from 'vue';
import Router from 'vue-router';
import setting from './router/setting';
import user from './router/user';
import teach from './router/teach';
import market from './router/market';
import finance from './router/finance';
import operation from './router/operation';
import statistics from './router/statistics';
import question from './router/question';
import book from './router/book';
import ask from './router/ask';

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [{
        path: '/login',
        name: 'Login',
        component: () =>
            import ( /* webpackChunkName: "login" */ './views/Login.vue')
    }, {
        path: '/',
        name: 'Main',
        component: () =>
            import ( /* webpackChunkName: "main" */ './views/Main.vue'),
        children: [
            ...setting,
            ...user,
            ...teach,
            ...market,
            ...finance,
            ...operation,
            ...statistics,
            ...question,
            ...book,
            ...ask
        ]
    }]
})
